import axios from 'axios';
import {backendHost} from '../../../../store/config';

export const putUsersCurrency = (params) => {
    return axios.put(`${backendHost}/api/admin/users/currency`, params);
};